// mat-paginator-intl.factory.ts
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export function matPaginatorIntlFactory(translate: TranslateService) {
   const intl = new MatPaginatorIntl();

   const setLabels = () => {
      intl.itemsPerPageLabel = translate.instant('PAGINATOR.ITEMS_PER_PAGE');
      intl.nextPageLabel = translate.instant('PAGINATOR.NEXT_PAGE');
      intl.previousPageLabel = translate.instant('PAGINATOR.PREVIOUS_PAGE');
      intl.firstPageLabel = translate.instant('PAGINATOR.FIRST_PAGE');
      intl.lastPageLabel = translate.instant('PAGINATOR.LAST_PAGE');
      intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
         if (length === 0 || pageSize === 0) {
            return translate.instant('PAGINATOR.RANGE_PAGE_EMPTY', { length });
         }
         const start = page * pageSize;
         const end = Math.min(start + pageSize, length);
         return translate.instant('PAGINATOR.RANGE_PAGE', { start: start + 1, end, length });
      };
      intl.changes.next(); // <-- ETTŐL frissül dinamikusan
   };

   setLabels(); // init
   translate.onLangChange.subscribe(() => setLabels()); // nyelvváltáskor újracímkéz

   return intl;
}
